import React from 'react';
import loadingCircle from '../../images/ajax-loader.gif';
// import Header from '../header';

var tablevalue={
    "Back/Not_Back": [
        {"0": "Back"},
        {"1": null},
        {"2": null}
    ],
    "Back/Not_Back(conf)": [
        {"0": 0.7617749571800232},
        {"1": null},
        {"2": null}
    ],
    "Blank/Imprint": [
        {"0": "Blank"},
        {"1": "Blank"},
        {"2": "Imprint"}
    ],
    "Blank/Imprint(conf)": [
        {"0": 0.9570484161376953},
        {"1": 0.8889168500900269},
        {"2": 0.9682064056396484}
    ],
    "Front/Not_Front": [
        {"0": "Front"},
        {"1": null},
        {"2": null}
    ],
    "Front/Not_Front(conf)": [
        {"0": 0.7314419746398926},
        {"1": null},
        {"2": null}
    ],
    "Image_name": [
       {"0": "0011-58BK_A-1.jpg"} ,
        {"1": "0011-58BK_A-2.jpg"},
        {"2": "0011-58BK_A-3.jpg"}
    ],
    "Multi/Single": [
        {"0": "Single"},
        {"1": "Single"},
        {"2": "Single"}],
    "Multi/Single(conf)":[
         {"0": 0.9991587400436401},
        {"1": 0.979719340801239},
        {"2": 0.9995999932289124}
    ],
    "Path": [
        {"0": "test_img\\0011-58BK_A-1.jpg"},
        {"1": "test_img\\0011-58BK_A-2.jpg"},
        {"2": "test_img\\0011-58BK_A-3.jpg"}
    ],
    "Side/Not_Side": [{"0": null},
        {"1": "Side"},
       { "2": "Side"}
    ],
    "Side/Not_Side(conf)": [
        {"0": null},
        {"1": 0.7704965472221375},
        {"2": 0.7740745544433594}
    ],
    "Top/Not_Top": [
        {"0": "Top"},
        {"1": "Top"},
        {"2": "Top"}
    ],
    "Top/Not_Top(conf)": [
        {"0": 0.9878988862037659},
        {"1": 0.8016859889030457},
        {"2": 0.9762000441551208}
    ]
}

// exportExcel() {
   
//     // var tablevalue = this.state.elasticData
//     var searchdata = [];
//     for (var i = 0; i < tablevalue.length; i++) {

//         var excelData = {
//             "Product Name": tablevalue["Image_name"][i][i],
//             "Blank-Imprint": tablevalue["Blank/Imprint"][i][i],
//             "Blank-Imprint Confidence": tablevalue["Blank/Imprint(conf)"][i][i],
//             "Shot View": tablevalue["Back/Not_Back"][i][i],
//             "Shot View Confidence": tablevalue["Back/Not_Back(conf)"][i][i],
//             "Single-Multi": tablevalue["Multi/Single"][i][i],
//             "Single-Multi Confidence": tablevalue["Multi/Single(conf)"][i][i]            
//         };
//         searchdata.push(excelData)
//     }

//     const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//     const fileExtension = '.xlsx';
//     const fileName = "BacktestExport";

//     const ws = XLSX.utils.json_to_sheet(searchdata);
//     const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
//     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//     const data = new Blob([excelBuffer], { type: fileType });
//     FileSaver.saveAs(data, fileName + fileExtension);

//     // document.getElementById("exportExcelBtn").removeAttribute("disabled");
//     // document.getElementById("exportExcelBtn").innerHTML = "Export";
    
// }

function TabTrail() {
    // console.log(tablevalue["Image_name"][1][1])
    return (
        <div className="table-a shadow">
            <div className="row ml-12 mb-4 tab-b">
            <ul class="nav nav-tabs" id="myTab1" role="tablist">
															<li class="nav-item">
																<a class="nav-link active" id="home-tab-1" data-toggle="tab" href="#home-1">
																	
																	<span class="nav-text h4">Image Analysis</span>
																</a>
															</li>
															<li class="nav-item">
																<a class="nav-link" id="profile-tab-1" data-toggle="tab" href="#home-2" aria-controls="profile">
																	
																	<span class="nav-text h4">Image Comparsion-Image Wise</span>
																</a>
															</li>
                                                            <li class="nav-item">
																<a class="nav-link" id="profile-tab-2" data-toggle="tab" href="#home-3" aria-controls="profile2">
																	
																	<span class="nav-text h4">Image Comparsion-Product Wise</span>
																</a>
															</li>
                                                            </ul>
            </div>
            <div class="tab-content mt-5" id="myTabContent1">
															<div class="tab-pane fade show active" id="home-1" role="tabpanel" aria-labelledby="home-tab-1">

                                                            <div className="row">
             <div className="col-md-1 mr-0 pr-0 ml-6 text-right"><label className="mt-2 ">SEARCH</label></div>
          <div className="col-md-4 my-2 my-md-0 ml-0">
          <div className="input-icon">
                <input type="text" className="form-control" placeholder="Search..." id="kt_datatable_search_query"/>
                <span>
                    <i className="flaticon2-search-1 text-muted"></i>
                </span>
          </div>
            </div>
            <div className="col-md-2 offset-md-4 mr-0 pr-0">
            <button className="btn btn-dark w-100  " onClick={()=>this.exportExcel()}>Export Report</button>
            </div>
        
                      </div>
                      <div className="row ml-10 mt-6">
                          <table>
                            {(this.props!=undefined && this.props.props.analyseClick==true && 
                            (this.props.props.classifyModel==undefined || this.props.props.classifyModel.Image_name==undefined
                                 || this.props.props.classifyModel.Image_name.length==0) &&
                            (this.props.props.colorModel==undefined || this.props.props.colorModel.Image_name==undefined
                                    || this.props.props.colorModel.Image_name.length==0)  
                            )?
                                 <img src={loadingCircle} />
                            :
                            <React.Fragment>
                               {(this.props!=undefined && this.props.props.classifyModel!=undefined && 
                               this.props.props.classifyModel.Image_name!=undefined && this.props.props.classifyModel.Image_name.length>0)?
                               
                               <React.Fragment> 
                                <tr> 
                                    <td><b>MODEL</b></td>
                                    {this.props.props.classifyModel.Blank_Imprint!=undefined?
                                        <td  colSpan="2"> <div className="td-h">BLANK IMPRINT</div></td>
                                    :""}
                                    {this.props.props.classifyModel.Back_Not_Back!=undefined?
                                        <td colSpan="2"> <div className="td-h">SHOT VIEW</div></td>
                                    :""}
                                    {this.props.props.classifyModel.Multi_Single!=undefined?
                                        <td colSpan="2"> <div className="td-h">SINGLE MULTI</div></td>
                                    :""}
                                    {this.props.props.colorModel!=undefined && this.props.props.colorModel.Image_name!=undefined?
                                        <td colSpan="2"><div className="td-h">COLOR CATEGORIZATION</div></td>
                                    :""}   
                                </tr>
                             
                            {(this.props.props.classifyModel.Image_name!=undefined && this.props.props.colorModel.Image_name!=undefined)?
                            <React.Fragment>
                                {this.props.props.classifyModel.Image_name.map((name,index)=>{
                                       return(
                                    <tr><td><b>{name[index]}</b></td>             
                                    {/* <td><img className="td-img" src="assets/media/logos/Image -1.svg" alt="modelomage"/></td>  */}
                                    {this.props.props.classifyModel.Blank_Imprint!=undefined?
                                     <td className="td-d">{this.props.props.classifyModel.Blank_Imprint[index][index]}</td>
                                    :""}
                                   {this.props.props.classifyModel.Blank_Imprint_conf!=undefined?
                                     <td className="td-d">{this.props.props.classifyModel.Blank_Imprint_conf[index][index]}</td>
                                    :""}
                                    {this.props.props.classifyModel.Back_Not_Back!=undefined?
                                     <td className="td-d">{this.props.props.classifyModel.Back_Not_Back[index][index]}</td>
                                    :""}
                                    {this.props.props.classifyModel.Back_Not_Back_conf!=undefined?
                                     <td className="td-d">{this.props.props.classifyModel.Back_Not_Back_conf[index][index]}</td>
                                    :""}
                                    {this.props.props.classifyModel.Multi_Single!=undefined?
                                     <td className="td-d">{this.props.props.classifyModel.Multi_Single[index][index]}</td>
                                    :""}
                                    {this.props.props.classifyModel.Multi_Single_conf!=undefined?
                                     <td className="td-d">{this.props.props.classifyModel.Multi_Single_conf[index][index]}</td>
                                    :""}
                                    {(this.props.props.colorModel!=undefined && this.props.props.colorModel.PCNA_colour!=undefined )?
                                     <td className="td-d">{this.props.props.colorModel.PCNA_colour[index][index]}</td>
                                    :""}
                                    {(this.props.props.colorModel!=undefined && this.props.props.colorModel.PCNA_colour!=undefined )?
                                     <td className="td-d">{this.props.props.colorModel.RGB_value[index][index]}</td>
                                    :""}
                                    </tr>
                                    )})}
                                    </React.Fragment>
                                    :""}
                                    </React.Fragment>
                            :
                            <React.Fragment>
                            {(this.props.props.colorModel.Image_name!=undefined && this.props.props.colorModel.Image_name.length>0)?
                            <React.Fragment>
                            {this.props.props.colorModel.Image_name.map((ImageName,index)=>{
                            return(
                                <tr><td><b>{ImageName[index]}</b></td>             
                                {/* <td><img className="td-img" src="assets/media/logos/Image -1.svg" alt="modelomage"/></td>  */}
                                <td className="td-d">{this.props.props.colorModel.PCNA_colour[index][index]}</td>
                                <td className="td-d">{JSON.stringify(this.props.props.colorModel.RGB_value[index][index])}</td>
                               
                                </tr>
                                )
                            })}
                            </React.Fragment>
                            :""}
                            </React.Fragment>
                            
                            }
                            </React.Fragment>
                                    }
                        
                               
                          </table>
                      </div>
                     
                                                            </div>
                                                            <div class="tab-pane fade " id="home-2" role="tabpanel" aria-labelledby="home-tab-2">
                                                            <div className="row">
                                                            <div className="col-md-1 mr-0 pr-0 ml-6 text-right"><label className="mt-2 ">SEARCH</label></div>
                                                            <div class="col-md-4 my-2 my-md-0 ml-0">
                                                            <div class="input-icon">
																<input type="text" class="form-control" placeholder="Search..." id="kt_datatable_search_query"/>
																<span>
																	<i class="flaticon2-search-1 text-muted"></i>
																</span>
															</div>
														</div>
                                                        <div className="col-md-2 offset-md-4 mr-0 pr-0">
                                                        <button className="btn btn-dark w-100  ">Export Report</button>
                                                        </div>
        
                      </div>
                      <div className="row ml-10 mt-6">
                          <table>
                              {/* <tr><td></td><td><b>MODEL</b></td><td  colspan="2"><div className="td-h">BLANK IMPRINT</div></td><td colspan="2"><div className="td-h">SHOT VIEW</div></td><td colspan="2"><div className="td-h">SINGLE MULTI</div></td><td colspan="2"><div className="td-h">COLOR CATEGORIZATION</div></td><td colspan="2"><div className="td-h">RIGHT ANGLED LEFT ANGLED</div></td></tr> */}
                            <tr className="tr-a "><td>
                                <div  className="td-a ">PRODUCT CODE<img  src="assets/media/logos/sort.svg"/></div></td>
                                <td><div  className="td-a pl-15"> IMAGE NAME 1<img src="assets/media/logos/sort.svg"/></div></td>
                                <td><div  className="td-a pl-15">IMAGE NAME 2<img className="ml-1" src="assets/media/logos/sort.svg"/></div></td>
                                <td><div  className="td-a pl-15">SSIM <img className="ml-1" src="assets/media/logos/sort.svg"/></div></td>
                                <td><div  className="td-a pl-15">SSIM %<img className="ml-1" src="assets/media/logos/sort.svg"/></div></td>
                                
                                <td><div  className="td-a "></div></td><td><div  className="td-a "></div></td><td></td></tr>

                                {this.props.props.imgAlignment!=undefined && this.props.props.imgAlignment.Alignment!=undefined?
                            <React.Fragment>
                                {this.props.props.imgAlignment.Alignment[0].Product_code.map((imageName, index)=>{
                                return(
                                 <tr><td><b>{imageName[index]}</b></td>
                                 <td><b>{this.props.props.imgAlignment.Alignment[1].Image_name_1[index][index]}</b></td>
                                 <td><b>{this.props.props.imgAlignment.Alignment[2].Image_Name_2[index][index]}</b></td>
                                 <td><b>{this.props.props.imgAlignment.Alignment[3].SSIM[index][index]}</b></td>
                                 <td><b>{this.props.props.imgAlignment.Alignment[4].SSIM_perc[index][index]}</b></td>                                 
                                </tr>
                                )                            
                            })}
                            </React.Fragment>
                            :""}
                                
                          </table>
                      </div>
                                                                </div>
                                                                <div class="tab-pane fade " id="home-3" role="tabpanel" aria-labelledby="home-tab-3">
                                                                <div className="row">
             <div className="col-md-1 mr-0 pr-0 ml-6 text-right"><label className="mt-2 ">SEARCH</label></div>
          <div class="col-md-4 my-2 my-md-0 ml-0">
          <div class="input-icon">
																<input type="text" class="form-control" placeholder="Search..." id="kt_datatable_search_query"/>
																<span>
																	<i class="flaticon2-search-1 text-muted"></i>
																</span>
															</div>
														</div>
                                                        <div className="col-md-2 offset-md-4 mr-0 pr-0">
                                                        <button className="btn btn-dark w-100  ">Export Report</button>
                                                        </div>
        
                      </div>
                      <div className="row ml-10 mt-6">
                          <table>
                              
                            <tr className="tr-a "><td>
                                <div  className="td-a ">PRODUCT NAME<img  src="assets/media/logos/sort.svg"/></div></td>
                                <td><div  className="td-a pl-15">PRODUCT IMAGE<img src="assets/media/logos/sort.svg"/></div></td>
                                <td><div  className="td-a pl-15">PRODUCT CODE<img className="ml-1" src="assets/media/logos/sort.svg"/></div></td>
                                <td><div  className="td-a pl-15">MINIMUM <img className="ml-1" src="assets/media/logos/sort.svg"/></div></td>
                                <td><div  className="td-a pl-15">MAXIMUM<img className="ml-1" src="assets/media/logos/sort.svg"/></div></td>
                                <td><div  className="td-a pl-15">MEDIAN <img className="ml-1" src="assets/media/logos/sort.svg"/></div></td>
                                </tr>

                                {this.props.props.imgAlignment!=undefined && this.props.props.imgAlignment.Alignment!=undefined?
                            <React.Fragment>
                            {this.props.props.imgAlignment.Alignment[0].Product_code.map((imageName, index)=>{
                                    
                                return(
                                 <tr><td><b>{imageName[index]}</b></td>
                                 <td className="td-d">{this.props.props.imgAlignment.Alignment[5].Minimum[index][index]}</td>
                                 <td className="td-d2">{this.props.props.imgAlignment.Alignment[6].Maximum[index][index]}</td>
                                 <td className="td-d">{this.props.props.imgAlignment.Alignment[7].Median[index][index]}</td>
                                </tr>
                                )                            
                            })}
                            </React.Fragment>:""}
                            
                                {/* <tr><td><b>ABC</b></td><td><img className="td-img" src="assets/media/logos/Image -1.svg" alt="modelomage"/></td>
                                <td >HL-104</td><td ><div className="td-d2 p-7">98.50%</div></td><td ><div className="td-d2 p-7">Blank</div></td>
                                <td ><div className="td-d2 p-7">98.50%</div></td></tr> */}
                                
                          </table>
                      </div>
                                                                </div>
                                                            </div>
                                                          
         
        </div>
       
        );
      }
export default TabTrail;